import { DataTable } from '../../components/admin/data-table';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListBulkActions } from '../Moonstar/MoonstarListBulkActions';

export const RegionList = () => (
  <MoonstarList sort={{ field: 'name', order: 'ASC' }}>
    <DataTable rowClick="edit" bulkActionButtons={<MoonstarListBulkActions />}>
      <DataTable.Col source="name" />
    </DataTable>
  </MoonstarList>
);
